export default "__VITE_ASSET__rR8FCrA4__"